import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog,MatCheckboxChange} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { duplicateZone } from '../../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, AuthFailedMessage } from '../../../../../app-general';
import {Router} from '@angular/router';
import { ApiService } from '../../../../../api.service';
import { getCampus, getBuilding, getUnit } from '../../../../../api';
import { appsettings } from '../../../../../app-settings';

@Component({
  selector: 'app-duplicate-zone',
  templateUrl: './duplicate-zone.component.html',
  styleUrls: ['./duplicate-zone.component.scss']
})

export class DuplicateZoneComponent implements OnInit {
  
  public floorDuplicateForm : FormGroup;
  selectedFloorId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  SpaceInfo;
  watcher: Subscription;
  columns = 4;
  firstcolumns = 2;
  minheight = "350px"; 
  rowHeight = "79px";
  checkspaceinfo = false;
  checkspaceselectall = false;
  select_SpaceIds = [];
  Campusdetails;
  Buildingdetails;
  selectedCampusId;
  selectedBuildingId;
  countchecked_id = 0;
  isCheckedAll = false;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<DuplicateZoneComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService,public dialog: MatDialog,private apiService: ApiService) { 
    
    this.selectedFloorId = data.FloorId;
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 2;  
          this.firstcolumns = 1;                  
          this.minheight = "auto";
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
          this.firstcolumns = 2;     
          this.minheight = "auto";
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 2;  
          this.firstcolumns = 1; 
          this.minheight = "350px";               
        }               
       else
       {
         this.columns = 4;  
         this.firstcolumns = 2;      
         this.minheight = "350px";               
       }
      }
    
    });
    
  }

  ngOnInit() {
    
    this.floorDuplicateForm = new FormGroup({
      floorname: new FormControl(''),    
      campusID: new FormControl(''), 
      buildID: new FormControl(''), 
      floorID: new FormControl(''), 
      campus : new FormControl('', [Validators.required]),    
      building : new FormControl('', [Validators.required]), 
      newfloorname:new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
    });
    
    this.floorDuplicateForm.get('floorname').disable();
    // this.floorDuplicateForm.get('buildingname').disable();
    // this.floorDuplicateForm.get('campusname').disable();
    
    this.getCampusDetails();    
    this.isCheckedAll = true;
    this.getUnitDetails();    
}

getCampusDetails()
{
  try
    {
      let campusid: getCampus = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey")
      }
      this.apiService.getCampusDetails(campusid).pipe(takeUntil(this._onDestroy))
      .subscribe((CampusDetails : any[])=>{  
        
        this.Campusdetails = CampusDetails["apiReturn"];       
      });  
    }
    catch (err) {
      throw new Error('duplicate-floor.component.ts' + ' - getCampusDetails() - ' + err.message);
    }
} 

getBuildingDetails(campusid)
{
  try
    {
      let buildid: getBuilding = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        campusId:parseInt(campusid)
      }
      this.apiService.getBuildingDetails(buildid).pipe(takeUntil(this._onDestroy))
      .subscribe((BuildingDetails : any[])=>{  
        
        this.Buildingdetails = BuildingDetails["apiReturn"];       
      });  
    }
    catch (err) {
      throw new Error('duplicate-floor.component.ts' + ' - getBuildingDetails() - ' + err.message);
    }
} 

changecampus_duplicate(campusid)
{
  this.selectedCampusId = campusid;
}

changebuilding_duplicate(buildingid)
{
  this.selectedBuildingId = buildingid;
}
  
getUnitDetails()
{
  try
  {
    let voiceLicense = localStorage.getItem("voice_license");
    let buildbyid : getUnit =  
    { 
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      floorId: this.selectedFloorId, 
      isIndoor:1,
      isNeedIntercom:parseInt(voiceLicense),
      isSubZone : 0
    }
    this.apiService.getUnitDetails(buildbyid).pipe(takeUntil(this._onDestroy))
    .subscribe((spaceinfo: any[]) => {
      
      this.SpaceInfo = spaceinfo["apiReturn"];    
      this.SpaceInfo.forEach(function (data)
      {      
          data['DeviceZoneCount'] = data.devicecount + data.Zonedevicecount;       
      });        
      this.toggleAll(this.isCheckedAll);
    });
  }
  catch (err) {
    throw new Error('duplicate-floor.component.ts' + ' - getUnitDetails() - ' + err.message);
  }
}  
  
toggleAll(event: any) {  
    if (event.checked || event == true) {
      this.select_SpaceIds = [];
      this.SpaceInfo.forEach(row => {
      
        var checkedid = row.UnitId
        this.select_SpaceIds.push(checkedid)
      });

      
    } else {
      
      this.select_SpaceIds = [];
      this.select_SpaceIds.length = 0;
    }
    this.isCheckedAll = this.isChecked();
  }

toggleresVisibility(checkedid, event: MatCheckboxChange) 
{ 
  if (event.checked) {
      const index = this.select_SpaceIds.indexOf(checkedid);
      if (index == -1) {
        this.select_SpaceIds.push(checkedid);
      }
    } else {
      const index = this.select_SpaceIds.indexOf(checkedid);
      if (index >= 0) {
        this.select_SpaceIds.splice(index, 1);
      }
    }
    this.isCheckedAll = this.isChecked();
    
}

exists(checkedid) {
  return this.select_SpaceIds.indexOf(checkedid) > -1;
};

isChecked() {
  return this.select_SpaceIds.length === this.SpaceInfo.length;
};

public onCloseCancel = () => 
  { 
    this.thisDialogRef.close('Cancel');  
    if(!SessionCheck(this.router))
    {
        return;
    }         
         
  }
handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.floorDuplicateForm.controls).forEach(field => { // {1}
        const control = this.floorDuplicateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('duplicate-floor.component.ts' + ' - handleInput() - ' + err.message);
    }
}

public duplicatefloorDetails = (duplicatefloorformvalue) => 
  {

    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.floorDuplicateForm.valid) { 
        this.duplicateZone(duplicatefloorformvalue)
      }
    }
    catch(err)
    {
      throw new Error('duplicate-floor.component.ts' + ' - duplicatefloorDetails() - ' + err.message);
    }
  }
  //When we click the Duplicate in zone a popup window , it will show two options. To Duplicate the zone or Save as Template.
  duplicateZone(duplicatefloorformvalue)
  {
    try
    {
      let saveclick = document.getElementById('btnsavefloorduplicateclick');
      if (this.select_SpaceIds.length==0 && this.SpaceInfo.length>0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Space to create as a new Zone.');   
        saveclick.className = 'clsfloordupsavebutton mat-raised-button';
        return;
      }
      if (this.select_SpaceIds.length==0 && this.SpaceInfo.length==0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Space to duplicate or create as a Template.');   
        saveclick.className = 'clsfloordupsavebutton mat-raised-button';
        return;
      }
      
      saveclick.className = 'clsfloordupsavebutton mat-raised-button disablebtn';
      
      let _Description = "";        
        if(duplicatefloorformvalue.description != "")
          _Description = duplicatefloorformvalue.description.replace(/\s+/g, ' ').trim();
        else
          _Description = "";
      
      let duplicatefloor: duplicateZone = {
        siteId:this.SiteId,
        authKey:localStorage.getItem("Authkey"),
        campusId:parseInt(duplicatefloorformvalue.campusID),
        buildingId:parseInt(duplicatefloorformvalue.buildID),
        zoneId:parseInt(duplicatefloorformvalue.floorID),
        newCampusId:parseInt(this.selectedCampusId),
        newBuildingId:parseInt(this.selectedBuildingId),
        newZoneName:duplicatefloorformvalue.newfloorname.replace(/\s+/g, ' ').trim(),
        newZoneDescription:_Description,//duplicatefloorformvalue.description,
        spaceIds:this.select_SpaceIds.toString()
      }      
      this.technologyoverlayService.duplicateZone(duplicatefloor).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: any[]) => 
      {          
        
          if(apiresponse["FloorId"] > 0)
          {                    
            saveclick.className = 'clsfloordupsavebutton mat-raised-button';
            this.thisDialogRef.close(apiresponse["FloorId"]); 
          }
          else if(apiresponse.toString() == "false")
          {
            generateAlertMessage(this.dialog, 'Zone Duplicate added failed.'); 
            saveclick.className = 'clsfloordupsavebutton mat-raised-button';      
            this.thisDialogRef.close("close"); 
          }
          else if(apiresponse["condition"] == "Authfalse")
          {    
              this.thisDialogRef.close('Cancel');              
              AuthFailedMessage(this.dialog,this.router);  
              return;       
          }
          else
          {            
            generateAlertMessage(this.dialog, "Zone name '" + apiresponse[0].FloorName + "' already exists.");              
            saveclick.className = 'clsfloordupsavebutton mat-raised-button';
            return; 
          }
          
      })
    }    
    catch(err)
    {
      throw new Error('duplicate-floor.component.ts' + ' - duplicateZone() - ' + err.message);
    }
  }

}
